import styled from "@emotion/styled";

import { fontSanFrancisco } from "shared/lib/styles";

export const Container = styled.div`
  display: inline-flex;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;

  padding: 16px;

  border-radius: 55px;

  outline: 8px #dae7ff solid;
  outline-offset: -8px;
`;

export const Wrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  border-radius: 42px;

  outline: 8px #001246 solid;

  overflow: hidden;
`;

export const Header = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  padding-block: 10px;
  padding-inline: 24px;

  color: #001246;
  font-weight: 600;
  font-size: 16px;
  font-family: SF Pro Text;
  line-height: 22px;
  word-wrap: break-word;

  background: #ffffff;
  border-block-end: 1px #cccccc solid;
`;

export const Frame = styled.div`
  inline-size: 375px;
  block-size: 744px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100%;
  block-size: 44px;
  padding-block: 10px;
  padding-inline: 24px;

  color: #001246;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontSanFrancisco};
  word-wrap: break-word;

  background: #ffffff;
  border-block-start: 1px #cccccc solid;
`;

export const FrontCamera = styled.span`
  inline-size: 24px;
  block-size: 24px;

  border-radius: 111px;

  background: #001246;
`;
